import React from "react";
import PropTypes from "prop-types";
import MainCharacteristics from "@/bit/components/next13.components.characteristics";
import BuyBox from "@/bit/components/next13.components.buy-box";
import Card from "@/component/card";
import Text from "@/bit/components/next13.components.text";
import PageSelector from "@/bit/components/next13.components.page-selector";
import ChannelLink from "@/component/channel-link";
import ImageSlider from "@/component/image-slider";

const ProductBanner = (props) => {
  const {
    productName,
    orionTitle,
    orionBanner,
    orionBuyBox,
    orionCharacs,
    orionSelector,
    orionImageSlider,
    simphePhoneFicha,
    alias,
  } = props;
  var showMobile = "";
  if (orionBanner && !orionBanner.showMobile) {
    showMobile = "notShowMobile";
  }

  return (
    <>
      <div
        className="product-banner container"
        data-cy="Section Product Banner"
      >
        <div
          className={`banner-left ${showMobile}`}
          data-cy="Product Banner Left"
        >
          <div className="banner-cards">
            {orionTitle && (
              <Text {...orionTitle["Text-1"]} kind="h" level="1" />
            )}

            {orionImageSlider ? (
              <ImageSlider
                name={orionImageSlider["Title-1"]}
                images={orionImageSlider["Images-1"]}
              />
            ) : (
              <Card {...orionBanner} setPriority={true}></Card>
            )}
          </div>
        </div>
        <div className="banner-right" data-cy="Product Banner Right">
          {orionSelector && Object.keys(orionSelector).length !== 0 && (
            <PageSelector {...orionSelector} />
          )}
          {orionCharacs?.positionTop ? (
            <>
              <MainCharacteristics {...orionCharacs} />
              <br />
              <BuyBox
                {...orionBuyBox}
                productName={productName}
                simplePhone={simphePhoneFicha}
                alias={alias}
              ></BuyBox>
            </>
          ) : (
            <>
              <BuyBox
                {...orionBuyBox}
                productName={productName}
                simplePhone={simphePhoneFicha}
                alias={alias}
              ></BuyBox>
              <br />
              <MainCharacteristics {...orionCharacs} />
            </>
          )}
          {orionBuyBox["Product-1"]?.["Channels-1"] && (
            <ChannelLink {...orionBuyBox["Product-1"]["Channels-1"]} />
          )}
        </div>
      </div>

      <style jsx>{`
        .product-banner {
          display: flex;
          flex-direction: column;
          gap: 1rem;
          min-height: 513px;
          padding-top: 2rem;
          @media screen and (max-width: 768px) {
            min-height: auto;
            padding-top: 0.5rem;
          }
          .banner-gap {
            display: none;
          }
          .banner-right {
            width: 100%;
          }
          .banner-left {
            display: block;
            height: ${productName === "salud" ? "unset " : "40vh"};
            .banner-cards {
              height: 100%;
              display: flex;
              flex-direction: column;
              :global(.card-column) {
                z-index: -1;
              }
            }
          }
          .notShowMobile {
            display: none;
            height: 0;
          }
        }
        @media screen and (min-width: 768px) {
          .product-banner {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            .banner-left {
              display: block;
              width: 45%;
              height: auto;
              .banner-cards {
                height: 100%;
                :global(.card-container) {
                  justify-content: flex-end;
                  :global(.card-glyph) {
                    width: 50%;
                    margin: 0 auto;
                  }
                  :global(.card-text-list) {
                    :global(.text-list) {
                      text-align: center;
                      margin: 0.5rem 2rem;
                    }
                  }
                }
              }
            }

            .notShowMobile {
              display: block;
            }
            .banner-gap {
              display: block;
              width: 4rem;
            }
            .banner-right {
              width: 48%;
            }
          }
        }
        @media screen and (min-width: 1024px) {
          .product-banner {
            .banner-gap {
              width: 8rem;
            }
          }
        }
      `}</style>
    </>
  );
};

ProductBanner.propTypes = {
  layout: PropTypes.string,
  backgroundColor: PropTypes.string,
  className: PropTypes.string,
};

ProductBanner.defaultProps = {
  layout: "",
  backgroundColor: "white",
  className: "",
};

export default ProductBanner;
